module.exports = __webpack_public_path__ + "media/images/resource-placeholder07-4f3ff879a10f3553529c689cc90412e0.jpg";